import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "regular", "active" ];
  static values = { visible: Boolean }

  show(event) {
    if (!this.visibleValue) {
      event.preventDefault();
      for (let element of this.regularTargets) {
        element.classList.add('link-box-hidden');
      }

      for (let element of this.activeTargets) {
        element.classList.remove('link-box-hidden');
      }
      this.visibleValue = true;
    }
  }
}
